import { Link } from 'react-router-dom';

export default function Logo() {
  return (
    <Link to="/" className="logo">
      I<span className="dot">·</span>DO<span className="dot">·</span>YOGA
    </Link>
  );
}
